// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2Yuv{text-align:center}.Y2Vm{margin:2.4rem 0 0}._290B{justify-content:center}._3wwo{display:flex}", ""]);
// Exports
exports.locals = {
	"header": "_2Yuv",
	"wrapp": "Y2Vm",
	"wrappCenter": "_290B",
	"card": "_3wwo"
};
module.exports = exports;
